import { render } from "./TeacherSharePage.vue?vue&type=template&id=e51be0c8&scoped=true"
import script from "./TeacherSharePage.vue?vue&type=script&lang=js"
export * from "./TeacherSharePage.vue?vue&type=script&lang=js"

import "./TeacherSharePage.vue?vue&type=style&index=0&id=e51be0c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e51be0c8"]])

export default __exports__